import { PolymorphicComponentProps } from "@omni/types/components/utils/polymorphic.types";
import React from "react";

import { card } from "../../card.style";

export type CardHeaderComponentProps = {};

export type CardHeaderProps<T extends React.ElementType> =
    PolymorphicComponentProps<T, CardHeaderComponentProps, "div">;

const CardHeader = <T extends React.ElementType = "div">({
    className,
    tag,
    ...attributes
}: CardHeaderProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);
    const { header } = card({});

    return (
        <Tag
            {...attributes}
            className={header({ className })}
        />
    );
};

export { CardHeader };
